import Page from "webPage/Page";
import $ from "jquery";
import ProductImageModal from "modal/ProductImageModal";
import ProductComparisonTable from "util/ProductComparisonTable";

Page.register(['page-template-products-scales-single', 'page-template-products-scales-single-xs-series', 'page-template-products-scales-single-fx-series'], () => {

    $('body').on('click', '.js-toggle-accordion', function () {
        $(this).parent('.icon-accordion').toggleClass('icon-accordion--active');
        return false;
    }).on('click', '.js-toggle-inner-accordion', function () {
        $(this).parent('.inner-accordion').toggleClass('inner-accordion--active');
        return false;
    }).on('click', '.js-product-image-modal', function () {
        let images = JSON.parse($(this).find('.js-images').text());
        (new ProductImageModal(images)).show();
        return false;
    }).on("click", ".js-switch-tab", function () {
        const tab = $(this).attr("data-tab");
        $(".js-switch-tab").removeClass("tabs__tab--active").filter("[data-tab='" + tab + "']").addClass("tabs__tab--active");
        $(".js-tab").removeClass("tabs__body--active").filter("[data-tab='" + tab + "']").addClass("tabs__body--active");

        return false;
    });

    let $comparison_section = $('.js-comparison-section');

    if ($comparison_section.length > 0) {
        new ProductComparisonTable($comparison_section);
    }

    registerParallaxScenes();
});


function registerParallaxScenes() {

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-features',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-features-circle-1').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-features-circle-1', 1, {yPercent: -50}, {yPercent: 5}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-addons',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-addons-circle').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-addons-circle', 1, {yPercent: 20}, {yPercent: -10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-matrix-table',
    //     duration: "200%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-matrix-table-circle').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-matrix-table-circle', 1, {yPercent: 10}, {yPercent: -20}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-matrix-table',
    //     duration: "400%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-series-text').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-series-text', 1, {yPercent: 5}, {yPercent: -10}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-addons',
    //     duration: "400%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-addons-text').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-addons-text', 1, {yPercent: 10}, {yPercent: -20}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-full-spec',
    //     duration: "400%",
    //     triggerHook: "onEnter",
    //     offset: $('.js-spec-text').position().top,
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-spec-text', 1, {yPercent: -10}, {yPercent: 10}),
    // ])));
}